import { toast } from 'react-toastify';

import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import { failedTranslate, successTranslate } from './actions';

export function* requestLang() {
  try {
    const { data } = yield call(api.get, 'idiomas');

    yield put(successTranslate(data));
  } catch (err) {
    toast.error('Erro ao buscar traduções');
    yield put(failedTranslate());
  }
}

export default all([takeLatest('@lang/REQUEST_TRANSLATE', requestLang)]);
